<div id="expired">
  <div *ngIf="! customMessage; else elseBlock" class="db-error-section">
    <p>{{'ERROR.PROCESSING_INTERRUPTED'|translate}}</p>
    <p *ngIf="isLanguageJapanese">{{'ERROR.PLEASE_TRY_AGAIN'|translate}}</p>
  </div>
  <ng-template #elseBlock>
    <div [innerHTML]="(customMessage || '') | safeHtml" class="db-error-section">>
      {{ customMessage }}
    </div>
  </ng-template>
</div>
